
import { TranslationRecord } from '../../types';

export const footer: TranslationRecord = {
  // Footer
  quickLinks: 'Γρήγοροι Σύνδεσμοι',
  privacyPolicy: 'Πολιτική Απορρήτου',
  rentalConditions: 'Όροι Ενοικίασης',
  cookiePolicy: 'Πολιτική Cookies',
  faq: 'Συχνές Ερωτήσεις',
  allRightsReserved: 'Όλα τα Δικαιώματα Διατηρούνται',
  legalHelp: 'Νομικά & Βοήθεια',
  footerDescription: 'Βρισκόμενο στο ζωντανό κέντρο της Θεσσαλονίκης, το Loena Luxury Suites προσφέρει προνομιακή διαμονή με συνδυασμό σύγχρονης πολυτέλειας και άνεσης.',
  
  // Company Information
  companyInfo: 'Στοιχεία Εταιρείας',
  companyName: 'Επωνυμία: Χρήστος Αθαν. Πετκάκης & Σια Ε.Ε.',
  vatId: 'ΑΦΜ',
  vatNumber: 'EL092615293',
  address: 'Έδρα',
  companyAddress: 'Ερνέστου Εμπράρ 13, Θεσσαλονίκη 54625',
  gemi: 'ΓΕΜΗ',
  gemiNumber: '038228205000',
};
